const FileIconNames = {
    'default': 'file',
    'application/pdf': 'file-pdf',
    'application/msword': 'file-word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-word',
    'image/png': 'image',
    'image/jpg': 'image',
    'image/jpeg': 'image',
    'image/gif': 'image',
    'video/mp4': 'file-video',
    'video/webm': 'file-video',
    'video/quicktime': 'file-video',
    'video/mpeg': 'file-video',
    'video/x-ms-wmv': 'file-video',
    'video/avi': 'file-video',
    'audio/mp3': 'music',
    'audio/mp4': 'music',
    'audio/mpeg': 'music',
    'audio/wav': 'music'
};
export default FileIconNames;
